export default __webpack_public_path__ + "static/media/0164.10651df8.jpg";